import {TanStackSavedViewIssues} from '../../routes/TanStackSavedViewIssues'
import {SavedViewBoard} from '../board/SavedViewBoard'
import {useSavedViewLayout} from './use-saved-view-layout'

interface Props {
  owner: string
  repo: string
  query: string
  preheatEnabled?: boolean
}

/** Renders the board or list issues surface based on the current saved-view layout. */
export function SavedViewIssuesForLayout({owner, repo, query, preheatEnabled}: Props) {
  const {layout} = useSavedViewLayout()

  return layout === 'board' ? (
    <SavedViewBoard owner={owner} repo={repo} query={query} />
  ) : (
    <TanStackSavedViewIssues owner={owner} repo={repo} query={query} preheatEnabled={preheatEnabled} />
  )
}
